import { render, staticRenderFns } from "./FooterSlider.vue?vue&type=template&id=97b232e0&scoped=true&"
import script from "./FooterSlider.vue?vue&type=script&lang=js&"
export * from "./FooterSlider.vue?vue&type=script&lang=js&"
import style0 from "./FooterSlider.vue?vue&type=style&index=0&id=97b232e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b232e0",
  null
  
)

export default component.exports